import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const updateStateOfUnreadMessages = createAsyncThunk('commonLocation/updateStateOfUnreadMessages', async (GetClient) => {
const response = await axios.post('https://api.zasway.com:8443/Staff/UpdateStatusOfUnreadMessages', GetClient, {mode:'cors'})
 
return response.data
})
export const GetCompanyIDWB = createAsyncThunk('commonLocation/GetCompanyIDWB', async (GetClient) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Common/GetCompanyIdForWebBooker', GetClient, {mode:'cors'})
   
  return response.data
  })
  export const GetCompanyDetails = createAsyncThunk('commonLocation/GetCompanyDetails', async (GetClient) => {
   
    const response = await axios.post('https://api.zasway.com:8443/Common/GetCompanyDetails ', GetClient, {mode:'cors'})
     
    return response.data
    })    
  
  export const GetCompanyTaxWB = createAsyncThunk('commonLocation/GetCompanyTaxWB', async (GetClient) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetTaxForWebBooker', GetClient, {mode:'cors'})
     
    return response.data
    }) 
    export const GetCompanyIdentifierWB = createAsyncThunk('commonLocation/GetCompanyIdentifierWB', async (GetClient) => {
      const response = await axios.post('https://api.zasway.com:8443/Common/GetCompanyIdentifierForWebBooker', GetClient, {mode:'cors'})
       
      return response.data
      })  
    
export const getDriverChatWithStaff = createAsyncThunk('commonLocation/getDriverChatWithStaff', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverChatss', GetClient, { mode: 'cors' })

  return response.data
})
export const deleteDriverChat = createAsyncThunk('commonLocation/deleteDriverChat', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Staff/DeleteDriverChat', GetClient, { mode: 'cors' })

  return response.data
})
export const sendMessageToDriver = createAsyncThunk('commonLocation/sendMessageToDriver', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Staff/SendMessage', GetClient, { mode: 'cors' })

  return response.data
})
export const sendMessageToStaff = createAsyncThunk('commonLocation/sendMessageToStaff', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Staff/SendMessage', GetClient, { mode: 'cors' })

  return response.data
})
export const getDriverUsersList = createAsyncThunk('Client/getDriverUsersList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetDriverUserList')

  return response.data
})
export const getDispatcherChats = createAsyncThunk('commonLocation/getDispatcherChats', async (GetClient) => {
  const response = await axios.post(' https://api.zasway.com:8443/Staff/GetTableSummaryDispatcherChatsList', GetClient, { mode: 'cors' })
  return response.data
})

export const getDispatcherChatsForNotification = createAsyncThunk('commonLocation/getDispatcherChats', async (GetClient) => {
  const response = await axios.post(' https://api.zasway.com:8443/Staff/GetTableSummaryDispatcherChatsList', GetClient, { mode: 'cors' })
  return response.data
})
export const getDiscountCodes = createAsyncThunk('commonLocation/getDiscountCodes', async (GetClient) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetDiscountCodes', GetClient, {mode:'cors'})
   
  return response.data
  })
  export const getClientList = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, {mode: 'cors'})
    return response.data
  })
  export const gettaxlist = createAsyncThunk('appCreditNote/getTaxList', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Common/GetTaxList', params, {mode:'cors'})
    return response.data
})
  export const addDiscountCodes = createAsyncThunk('commonLocation/addDiscountCodes', async (GetClient) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/AddDiscountCodes', GetClient, {mode:'cors'})
     
    return response.data
    })
    export const updateDiscountCodes = createAsyncThunk('commonLocation/updateDiscountCodes', async (GetClient) => {
      const response = await axios.post('https://api.zasway.com:8443/Common/UpdateDiscountCodes', GetClient, {mode:'cors'})
       
      return response.data
      })
      export const deleteDiscountCodes = createAsyncThunk('commonLocation/deleteDiscountCodes', async (GetClient) => {
        const response = await axios.post('https://api.zasway.com:8443/Common/DeleteDiscountCodes', GetClient, {mode:'cors'})
         
        return response.data
        })
export const SendBroadCastMessageToAllActiveDriver = createAsyncThunk('Staff/SendBroadCastMessageToAllActiveDriver', async (SendMessage) => {

  const response = await axios.post('https://api.zasway.com:8443/Staff/SendBroadCastMessageToAllActiveDriver', SendMessage, { mode: 'cors' })

  return response.data
})
export const UpdateStatusOfNotificationMessages = createAsyncThunk('commonLocation/UpdateStatusOfNotificationMessages', async (GetClient) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Staff/UpdateStatusOfNotificationMessages', GetClient, {mode:'cors'})
    
  return response.data
  })  

export const getChat = createAsyncThunk('commonLocation/getChat', async (GetClient) => {
        
  const response = await axios.post('https://api.zasway.com:8443/Staff/GetDispatcherChatss', GetClient, {mode:'cors'})
    
  return response.data
})

export const addLocation = createAsyncThunk('/commonLocation/addLocation', (Location) => {
  return { data: Location }
})
export const getDistance_Time = createAsyncThunk('/commonLocation/getDistance_Time', (distance_time) => {

  return { data: distance_time }
})
export const CloseModel = createAsyncThunk('/commonLocation/CloseModel', (IsClosed) => {

  return { data: IsClosed }
})
export const ResetCloseModel = createAsyncThunk('/commonLocation/ResetCloseModel', () => {

  return { data: false }
})

export const getAPIKEY = createAsyncThunk('commonLocation/getAPIKEY', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Configuration/GetConfigurationData', params, { mode: 'cors' })

  return response.data

})
export const getBookingHistoryLog = createAsyncThunk('commonLocation/getBookingHistoryLog', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingHistoryLog', params, { mode: 'cors' })

  return response.data

})
export const GetUpdateStatusOfUnreadMessagesForDriver = createAsyncThunk('commonLocation/UpdateStatusOfUnreadMessagesForDriver', async (GetClient) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Staff/UpdateStatusOfUnreadMessagesForDriver', GetClient, { mode: 'cors' })
   
  return response.data
})

export const getChatForNotification = createAsyncThunk('commonLocation/getChat', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Staff/GetDispatcherChatss', GetClient, { mode: 'cors' })

  return response.data
})
export const CommonSlice = createSlice({
  name: 'commonLocation',
  initialState: {
    data: [],
    totalDistance_time: null,
    GetApiKeys: [],
    addressLocation: null,
    IsClosed: false,
    Loader: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(addLocation.pending, (state) => {
        state.Loader = true
      })
      .addCase(addLocation.fulfilled, (state, action) => {
        state.Loader = false
        state.addressLocation = action.payload.data
        state.IsClosed = false
      })
      .addCase(getDistance_Time.fulfilled, (state, action) => {
        state.totalDistance_time = action.payload.data

      })
      .addCase(CloseModel.fulfilled, (state, action) => {

        state.IsClosed = action.payload.data
      })
      .addCase(ResetCloseModel.fulfilled, (state, action) => {

        state.IsClosed = action.payload.data
      })
      .addCase(getAPIKEY.fulfilled, (state, action) => {

        state.GetApiKeys = action.payload

      })
     
      .addCase(SendBroadCastMessageToAllActiveDriver.pending, (state) => {
        state.Loader = true
     }) 
     .addCase(SendBroadCastMessageToAllActiveDriver.fulfilled, (state) => {
      state.Loader = false
   }) 
  }
})

export default CommonSlice.reducer